// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"725":"1c7ba723","978":"e3daff61"}[chunkId] + ".css";
};